<template>
    <div id="candidates-container">
        <div id="app-layout-right-column__content__title">
            <span>Candidates</span>
        </div>
        <CandidateFilters />
        <div v-if="!image" id="app-layout-right-column__content__message">
            <span>Please select an asset in the Media tab to see related Candidates</span>
        </div>
        <div class="scrollable-con">
            <CandidateTemplate v-for="candidate in filteredCandidates" :key="candidate.id"
                               :candidate="candidate"></CandidateTemplate>
        </div>
    </div>
</template>

<script>
import CandidateFilters from "@/components/app/candidates/CandidateFilters.vue";
import CandidateTemplate from "@/components/app/candidates/CandidateTemplate.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {CandidateFilters, CandidateTemplate},
    computed: {
        ...mapState("User", ["account"]),
        ...mapState("Projects", ["image"]),
        ...mapGetters('User', ['isGuest']),
        ...mapGetters('UI', ['filteredCandidates']),
    },
}
</script>

<style lang="scss" scoped>
#candidates-container {
    display: grid;
    align-content: start;

    > span {
        text-align: center;
        width: 100%;
        display: block;
        font-size: 0.9rem;
    }
}
</style>